module.exports = __webpack_public_path__ + "1b4a52c55f1f8f6ae40fad1ee63d4986.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1147
// module chunks = 0